/**
 * Base URL for the REST API (includes `/api`, no trailing slash).
 *
 * Resolution order:
 *   1. `REACT_APP_API_URL` — overrides everything (production / custom setups).
 *   2. `window.location.hostname` + `REACT_APP_API_PORT` (defaults to `5000`).
 *      This lets phones / other machines on the LAN hit the dev server
 *      instead of their own localhost.
 *   3. `http://localhost:<port>/api` as a final fallback (SSR, tests).
 */

const DEFAULT_API_PORT: string =
  (process.env.REACT_APP_API_PORT as string | undefined) || '5000';

export function getApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_API_URL as string | undefined;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:${DEFAULT_API_PORT}/api`;
  }
  return `http://localhost:${DEFAULT_API_PORT}/api`;
}
